const frontendUriWeb = process.env.REACT_APP_FRONTEND_URI_WEB;

export const callbackUri = frontendUriWeb;
